import axiosInstance from '../utils/axiosConfig';

export const dashboardService = {
    getMetrics: async () => {
        try {
            const response = await axiosInstance.get('/api/dashboard/metrics/');
            return response.data;
        } catch (error) {
            console.error('Error fetching dashboard metrics:', error);
            throw error;
        }
    },

    getUserInfo: async () => {
        try {
            const response = await axiosInstance.get('/api/dashboard/user-info/');
            return response.data;
        } catch (error) {
            console.error('Error fetching user info:', error);
            throw error;
        }
    }
}; 